const apiUrl = process.env.REACT_APP_API_URL;

export async function TrySignup(username, password) {
  const response = await fetch(`${apiUrl}/user/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username,
      password,
    }),
  });

  if (!response.ok) {
    const errorResponse = await response.json();
    const errorMessage =
      errorResponse?.message || "Oops, something went wrong!";
    throw new Error(errorMessage);
  }

  return response.json();
}
